export default __webpack_public_path__ + "static/media/behavior_reading_deficits_table2.78fa0ee8.png";